import { Component, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'step-component',
  styleUrl: 'step-component.scss',
  shadow: true,
})
export class StepComponent {
  @Prop() stepNum: number;
  @Prop() description: string = '';
  @Prop() currentStep: number;
  @Prop() numOfSteps: number;
  @Prop() isVertical: boolean = false;

  private determineStepPostition(): string {
    if (this.stepNum === 1) return 'description first';
    return this.stepNum - this.numOfSteps === 0 ? 'description last' : 'description middle';
  }

  private determineStepState(): string {
    if (this.stepNum < this.currentStep) return 'step-child completed';
    return this.stepNum === this.currentStep ? 'step-child current' : 'step-child to-be-done';
  }

  private determineDescriptionClass(): string {
    if (this.isVertical) return 'description first';
    return this.determineStepPostition();
  }

  render() {
    return (
      <Host class={this.isVertical ? 'vertical' : 'horizontal'}>
        <div class="step-parent">
          <div class={this.determineStepState()}>{this.determineStepState() === 'step-child completed' ? <i class="material-icons-outlined">check</i> : this.stepNum}</div>
          <div class={this.determineDescriptionClass()}>{this.description}</div>
        </div>
      </Host>
    );
  }
}
